<div
  class="bfx-field bfx-field-container bfx-field-active-subtle bfx-field-sm-subtle"
  style.width="100%"
>
  <input
    type="number"
    #hours
    min="0"
    max="23"
    placeholder="HH"
    (input)="onInput($event)"
    [disabled]="disabled"
    [(ngModel)]="hour"
    (keydown)="onKeyDown($event)"
    (focus)="onFocus($event)"
    (focusin)="lastActive = 'hours'"
    (blur)="onBlur($event)"
    maxlength="2"
    minlength="2"
    class="bfx-field-text bfx-field-placeholder-sm-subtle bfx-field-placeholder-active-subtle time-input"
    [ngClass]="{'bfx-field-inputted-disabled-subtle' : disabled}"
  />:<input
    type="number"
    min="0"
    max="59"
    placeholder="MM"
    (input)="onInput($event)"
    #minutes
    [disabled]="disabled"
    [(ngModel)]="minute"
    (keydown)="onKeyDown($event)"
    (focus)="onFocus($event)"
    (focusin)="lastActive = 'minutes'"
    (blur)="onBlur($event)"
    maxlength="2"
    minlength="2"
    class="bfx-field-text bfx-field-placeholder-sm-subtle bfx-field-placeholder-active-subtle time-input"
    [ngClass]="{'bfx-field-inputted-disabled-subtle' : disabled}"
  />
  <ng-container *ngIf="showSeconds"> : </ng-container>
  <input
    *ngIf="showSeconds"
    type="number"
    min="0"
    max="59"
    placeholder="SS"
    (input)="onInput($event)"
    #seconds
    [disabled]="disabled"
    [(ngModel)]="second"
    (keydown)="onKeyDown($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (focusin)="lastActive = 'seconds'"
    minlength="2"
    maxlength="2"
    class="bfx-field-text bfx-field-placeholder-sm-subtle bfx-field-placeholder-active-subtle time-input"
    [ngClass]="{'bfx-field-inputted-disabled-subtle' : disabled}"
  />
</div>
